export default __webpack_public_path__ + "static/media/amanda-baroni-perfil.a34e6275.jpg";